// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleOptionSelect_container__pJzEd","option":"SingleOptionSelect_option__0cMVc","selected":"SingleOptionSelect_selected__3Blf7"};